var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"base-price",style:({color: _vm.color})},[_vm._v(" ¥ "),_c('em',[_vm._v(_vm._s(_vm.priceArr[0]))]),_vm._v("."+_vm._s(_vm.priceArr[1])+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }